import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: 'var(--bg-card)', borderTop: '1px solid var(--border-light)', padding: '3rem 0 2rem' }} className="!mx-[10px]">
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem', marginBottom: '3rem' }}>
          {/* Brand Section */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
              <img
                src="https://customer-assets.emergentagent.com/job_4c223b67-9c3e-4e9b-9f63-72b14bc072ff/artifacts/swml20qc_Maroon%20%26%20Beige%20Modern%20Restaurant%20Menu%20Menu%20Portrait%20%282%20Page%29.png"
                alt="The VEC Logo"
                style={{ height: '40px', width: 'auto' }} className="!mx-[10px]" />

            </div>
            <p className="body-small !mx-[10px]" style={{ marginBottom: '1.5rem', lineHeight: 1.6 }}>
              Where wholeness meets strategy — building the clarity, structure & systems that move meaningful visions forward.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1.5rem' }} className="!mx-[10px]">
              <a href="mailto:hello@thevecllc.com" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                <Mail size={16} />
                hello@thevecllc.com
              </a>
              <a href="tel:7572558491" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                <Phone size={16} />
                757-255-8491
              </a>
            </div>
            {/* Social Media Links */}
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }} className="!mx-[10px]">
              <a
                href="https://www.facebook.com/TheVisionExecutionCo"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: '2.5rem',
                  height: '2.5rem',
                  borderRadius: '50%',
                  background: 'var(--accent-grey-200)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'var(--text-primary)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'var(--accent-grey-200)'}>

                <Facebook size={18} color="var(--text-primary)" />
              </a>
              <a
                href="https://www.instagram.com/theve.co/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: '2.5rem',
                  height: '2.5rem',
                  borderRadius: '50%',
                  background: 'var(--accent-grey-200)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'var(--text-primary)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'var(--accent-grey-200)'}>

                <Instagram size={18} color="var(--text-primary)" />
              </a>
              <a
                href="https://www.linkedin.com/company/the-vision-execution-co/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  width: '2.5rem',
                  height: '2.5rem',
                  borderRadius: '50%',
                  background: 'var(--accent-grey-200)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'var(--text-primary)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'var(--accent-grey-200)'}>

                <Linkedin size={18} color="var(--text-primary)" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontSize: '0.875rem', fontWeight: '500', marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '0.05em' }} className="!font-medium">Quick Links</h4>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <li><Link to="/" style={{ textDecoration: 'none', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>Home</Link></li>
              <li><Link to="/about" style={{ textDecoration: 'none', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>About</Link></li>
              <li><Link to="/products" style={{ textDecoration: 'none', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>Our Products & Services</Link></li>
              <li><Link to="/join-ewc" style={{ textDecoration: 'none', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>Join the EWC</Link></li>
              <li><Link to="/contact" style={{ textDecoration: 'none', color: 'var(--text-secondary)', fontSize: '0.875rem' }}>Contact</Link></li>
            </ul>
          </div>

          {/* Values */}
          <div>
            <h4 style={{ fontSize: '0.875rem', fontWeight: '500', marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '0.05em' }} className="!font-medium !ml-[5px]">Our Values</h4>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }} className="!text-left">
              <li><span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>Human Before Hustle</span></li>
              <li><span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>Systems with Soul</span></li>
              <li><span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>Vision with Vitality</span></li>
              <li><span style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>Sacred Execution</span></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ paddingTop: '2rem', borderTop: '1px solid var(--border-light)', textAlign: 'center' }}>
          <p className="caption" style={{ margin: 0 }}>
            © {currentYear} The Vision Execution Company. Building businesses from the inside out.
          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;